import React from 'react'
import Progress from './Progress'
import appconstant from '../../../themes/appconstant';
import { useSelector } from 'react-redux';

const ProgressChart = () => {
  const chartData = useSelector((state) => state.dashboardReducer);
  
  const total = chartData.logMood + chartData.community + chartData.journaling + chartData.affirmation + chartData.logThoughts + chartData.innerCircleCount + chartData.encouragementGroupCount
  const logMoodPer = ((chartData.logMood / total) * 100) || 0;
  const logThoughtsPer = ((chartData.logThoughts / total) * 100) || 0;
  const communityPer = ((chartData.community / total) * 100) || 0;
  const journalingPer = ((chartData.journaling / total) * 100) || 0;
  const affirmationPer = ((chartData.affirmation / total) * 100) || 0;
  const innerCircle = ((chartData.innerCircleCount / total) * 100) || 0;
  const encouragementGroupCount = ((chartData.encouragementGroupCount / total) * 100) || 0;


  return (
    <div className='p-7 w-full'>
      <Progress label={appconstant.logmood} value={chartData.logMood} width={`${logMoodPer}%`} />
      <Progress label={appconstant.logthought} value={chartData.logThoughts} width={`${logThoughtsPer}%`} />
      <Progress label={appconstant.community} value={chartData.community} width={`${communityPer}%`} />
      <Progress label={appconstant.encouragmentGroup} value={chartData.encouragementGroupCount} width={`${encouragementGroupCount}%`} />
      <Progress label={appconstant.innerCircle} value={chartData.innerCircleCount} width={`${innerCircle}%`} />
      <Progress label={appconstant.journaling} value={chartData.journaling} width={`${journalingPer}%`} />
      <Progress label={appconstant.affirmation} value={chartData.affirmation} width={`${affirmationPer}%`} />
      {/* <Progress label={appconstant.meditation} value="NA" width="0" />
      <Progress label={appconstant.directCare} value="NA" width="0" /> */}
    </div>
  )
}

export default ProgressChart;